/* Complementos: telas do Império, loja de barris, áudio e nomes de serviço
   que vêm da configuração da Season. */
export const OIL_DICT_EXTRA = {
  // Império
  'Nenhuma usina comprada': { zh: '尚未購買鑽油塔', en: 'No rig bought yet' },
  'Nenhuma envasadora': { zh: '尚未購買裝桶廠', en: 'No bottling plant yet' },
  '— NÃO COMPRADA': { zh: '— 未購買', en: '— NOT BOUGHT' },
  '🔒 USINA LV.': { zh: '🔒 鑽油塔 LV.', en: '🔒 RIG LV.' },
  '🔒 ENVASADORA LV.': { zh: '🔒 裝桶廠 LV.', en: '🔒 BOTTLING PLANT LV.' },
  ': rende de': { zh: '：產出', en: ': yields' },
  'Suas usinas:': { zh: '你的鑽油塔：', en: 'Your rigs:' },
  'Suas envasadoras:': { zh: '你的裝桶廠：', en: 'Your bottling plants:' },
  'EXTRAIR': { zh: '開採', en: 'EXTRACT' },
  'ENVASAR': { zh: '裝桶', en: 'BOTTLE' },
  'CONSTRUIR ENVASADORA': { zh: '建造裝桶廠', en: 'BUILD BOTTLING PLANT' },
  '📈 Bolsa do Petróleo · Inventário (': { zh: '📈 石油交易所 · 庫存（', en: '📈 Oil Exchange · Inventory (' },
  'Bolsa do Petróleo': { zh: '石油交易所', en: 'Oil Exchange' },
  'VENDER': { zh: '賣出', en: 'SELL' },
  'Vender': { zh: '賣出', en: 'Sell' },
  'valor unitário:': { zh: '單價：', en: 'unit value:' },
  '· extração': { zh: '· 開採', en: '· extraction' },
  'galpão': { zh: '倉庫', en: 'warehouse' },
  'Galpão': { zh: '倉庫', en: 'Warehouse' },
  'Respeito de hoje': { zh: '今日聲望', en: "Today's Respect" },
  'Dano': { zh: '傷害', en: 'Damage' },
  'Dano de': { zh: '傷害', en: 'Damage of' },
  '+ amassa a usina': { zh: '+ 損壞鑽油塔', en: '+ dents the rig' },
  '+ amassa a envasadora': { zh: '+ 損壞裝桶廠', en: '+ dents the bottling plant' },
  'amassa a usina': { zh: '損壞鑽油塔', en: 'dents the rig' },
  'amassa a envasadora': { zh: '損壞裝桶廠', en: 'dents the bottling plant' },

  // Áudio
  'Mudo': { zh: '靜音', en: 'Mute' },
  'TUDO MUDO': { zh: '全部靜音', en: 'ALL MUTED' },
  'DESLIGADO': { zh: '已關閉', en: 'OFF' },
  '🔊 LIGADO': { zh: '🔊 已開啟', en: '🔊 ON' },
  'Música': { zh: '音樂', en: 'Music' },
  '🎵 LIGADA': { zh: '🎵 已開啟', en: '🎵 ON' },

  // Nomes de serviço (vêm da Season)
  'Interceptação de Carga': { zh: '貨物攔截', en: 'Cargo Interception' },
  'Incidente na Plataforma': { zh: '平台事故', en: 'Platform Incident' },
  'Manipulação Clandestina': { zh: '地下操盤', en: 'Clandestine Manipulation' },
  'Assalto ao Cofre da Bolsa FOX': { zh: 'FOX 交易所金庫大劫案', en: 'FOX Exchange Vault Heist' },
  'Revela apenas faixa aproximada de FOX Dólar, níveis públicos das instalações e estado aproximado de proteção.': { zh: '只揭露 FOX Dólar 的大致區間、設施的公開等級，以及大略的防護狀態。', en: 'Reveals only the approximate FOX Dólar range, public facility levels and rough protection status.' },
};
